import React from "react";
import { PlaceOfDeliveryConsumptionSimplifiedDTO } from "features/placeOfDelivery/dtos/PlaceOfDeliveryConsumptionSimplifiedDTO";
import CommodityIcon from "features/shared/components/icons/CommodityIcon";
import RoundButton from "features/shared/components/buttons/RoundButton";
import { Nullable } from "features/shared/types/nullable";
import NumberFormatter from "features/shared/components/formatters/NumberFormatter";
import InfoItemMobile from "features/shared/components/infoItem/InfoItemMobile";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { getQueryParams } from "features/shared/helpers/queryParams";

type Props = {
  consumption: PlaceOfDeliveryConsumptionSimplifiedDTO;
};

const PlaceOfDeliveryConsumptionSimplified = ({ consumption }: Props) => {
  // history
  const history = useHistory();

  // translations
  const tLabels = useTranslation("placeOfDelivery\\placeOfDelivery").t;

  // sub-renders
  const renderConsumption = (value: Nullable<number> | undefined) => {
    if (value !== undefined && value !== null) {
      return (
        <span>
          <NumberFormatter amount={value} decimalPlaces={3} />
          <span className="d-sm-none small"> MW</span>
        </span>
      );
    } else {
      return <>-</>;
    }
  };

  // helpers
  const getConsumptionTitle = (type: "plan" | "real") => {
    let typeText = tLabels(
      `placeOfDeliveryConsumptionSimplifiedHeader.${type}Consumption`
    );
    let consumptionText = tLabels(
      "placeOfDeliveryConsumptionSimplifiedHeader.consumption"
    );
    return `${typeText} ${consumptionText}:`;
  };

  // handlers
  const showDetailHandler = () => {
    history.push({
      pathname: `${
        consumption.isProduction ? "production" : "consumption"
      }-history/${consumption.placeOfDeliveryId}`,
      state: consumption.year,
      search: consumption.isProduction
        ? getQueryParams(
            "isProduction",
            String(consumption.isProduction)
          ).toString()
        : undefined,
    });
  };

  // render
  return (
    <div className="row no-gutters align-items-center">
      <div className="col">
        <div className="row no-gutters align-items-center">
          <div className="col-sm text-truncate">
            <div className="d-flex align-items-center">
              <CommodityIcon
                commodityDetail={consumption.commodityDetail!}
                includeColor
                isProduction={consumption.isProduction}
                size="lg"
              />
              <div className="ml-2 overflow-hidden">
                <div className="text-truncate mw-100">
                  {consumption.placeOfDeliveryName}
                </div>
                <div className="small text-muted text-truncate mw-100">
                  {consumption.placeOfDeliveryAddress}
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm text-sm-center">
            <InfoItemMobile
              title={getConsumptionTitle("plan")}
              value={
                consumption.isProduction
                  ? "-"
                  : renderConsumption(consumption.planConsumption)
              }
              hideTitleOn="sm"
              valueClassName="mr-auto mr-sm-0"
            />
          </div>
          <div className="col-sm text-sm-center">
            <InfoItemMobile
              title={getConsumptionTitle("real")}
              value={renderConsumption(consumption.realConsumption)}
              hideTitleOn="sm"
              valueClassName="mr-auto mr-sm-0"
            />
          </div>
        </div>
      </div>
      <div className="col-auto">
        <RoundButton onClickHandler={showDetailHandler} />
      </div>
    </div>
  );
};

export default PlaceOfDeliveryConsumptionSimplified;
